// extracted by mini-css-extract-plugin
export var wrap = "styles-module--wrap--1JNOy";
export var scrollPart = "styles-module--scrollPart--g7spZ";
export var scrollPart_animatedInner = "styles-module--scrollPart_animatedInner--3QdPM";
export var animatedBlock = "styles-module--animatedBlock--1ydUH";
export var bgImage = "styles-module--bgImage--2BUH5";
export var title = "styles-module--title--3d4L-";
export var bgImage_hide = "styles-module--bgImage_hide--2nsPq";
export var clone = "styles-module--clone--1uNu2";
export var clone_hide = "styles-module--clone_hide--2gAQr";